export const CALLBACK_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
